export default "__VITE_ASSET__3254557d__"